
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/item/[slug]",
      function () {
        return require("private-next-pages/menu/item/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/item/[slug]"])
      });
    }
  